document.addEventListener("DOMContentLoaded", function () {
	// Responsive initialization for .tag-carousel-colorpicker
	function initializeColorPickerFlickity() {
		var groupCellsValue;

		// Check screen width and set groupCells value accordingly
		if (window.innerWidth < 575.98) {
			groupCellsValue = 2; // Show 2 slides on small screens
		} else if (window.innerWidth < 767.98) {
			groupCellsValue = 4; // Show 4 slides on medium screens
		} else if (window.innerWidth < 991.98) {
			groupCellsValue = 3; // Show 4 slides on medium screens
		} else if (window.innerWidth < 1199.98) {
			groupCellsValue = 4; // Show 4 slides on medium screens
		} else if (window.innerWidth < 1399.98) {
			groupCellsValue = 5; // Show 4 slides on medium screens
		} else {
			groupCellsValue = 8; // Show 8 slides on larger screens
		}

		// Destroy the instance if it exists
		if (window.flktyColorPicker) {
			window.flktyColorPicker.destroy();
		}

		// Initialize Flickity for .tag-carousel-colorpicker with responsive groupCells
		window.flktyColorPicker = new Flickity(".tag-carousel-colorpicker", {
			groupCells: groupCellsValue,
			cellAlign: "left",
			contain: true,
			selectedAttraction: 0.2,
			friction: 0.8,
			pageDots: false,
		});
	}
	// Initialize Flickity for .tag-carousel-colorpicker on page load
	initializeColorPickerFlickity();

	// Attach to window for external use in product-apparel-alpine-global-store.js
	window.initializeColorPickerFlickity = initializeColorPickerFlickity;

	// Reinitialize Flickity for .tag-carousel-colorpicker on window resize
	window.addEventListener("resize", function () {
		initializeColorPickerFlickity();
	});

	// Highlight the bootstrap accordion item in the add artwork section of the order process
	const accordionItems = document.querySelectorAll(".accordion-item");
	accordionItems.forEach((item) => {
		const button = item.querySelector(".accordion-button");
		button.addEventListener("click", function () {
			accordionItems.forEach((accordionItem) => {
				const accordionButton = accordionItem.querySelector(".accordion-button");
				if (accordionButton.getAttribute("aria-expanded") === "true") {
					accordionItem.classList.add("border", "border-3");
				} else {
					accordionItem.classList.remove("border", "border-3");
				}
			});
		});
	});
});